'use strict';
import angular from 'angular';
var CartSummaryController = /** @class */ (function () {
    /*@ngInject*/
    function CartSummaryController(Auth, $state, $scope, $rootScope, $location, $mdDialog, CartService, SettingsService) {
        var _this = this;
        this.subTotal = 0;
        this.freeShipping = 250;
        //dummie date
        //promos = [{id: 'Wellevate Member', detail: '-$20.00'}];
        this.promos = [];
        this.setLinkStatus = function () {
            if (this.uiRouterState == 'reviewOrder') {
                this.CartService.setLinkStatus('edit');
            }
        };
        this.addPromoCode = function () {
            if (this.promos.length === 0 || this.promos[0].promoCode.length) {
                var newItemNo = this.promos.length + 1;
                this.promos.push({
                    "discountName": '',
                    "promoCode": '',
                });
            }
        };
        this.editPromoCode = function ($event, promoCode) {
            var self = this;
            self.promoCode = promoCode;
            // if (self.promos.some((promo)=>promo.promoCode == self.promoCode)) return;
            var currPromo = self.promos.find(function (promo) {
                return promo.promoCode === self.promoCode;
            });
            self.discountDebugger = self.originalDiscountDebugger;
            currPromo.error = '';
        };
        this.clearPromoCode = function (currPromo) {
            var self = this;
            self.promoCode = '';
            self.discountDebugger = self.originalDiscountDebugger;
            currPromo.error = '';
            currPromo.promoCode = '';
        };
        this.loadingApplypromocode = '';
        this.validatePromoCode = function ($event, promoCode) {
            var self = this;
            self.loadingApplypromocode = promoCode;
            self.promoCode = promoCode;
            if (!self.promoCode) {
                return;
            }
            var currPromo = self.promos[self.promos.length - 1];
            this.CartService.addPromoCode(promoCode)
                .then(function (response) {
                var messages = [];
                if (response.warnings.length) {
                    messages = messages.concat(response.warnings);
                }
                if (response.errors.length) {
                    messages = messages.concat(response.errors);
                }
                if (messages.length) {
                    currPromo.error = messages.join(' ');
                    self.discountDebugger = (response.cart || {}).discountDebugger || self.discountDebugger || [];
                }
                else {
                    currPromo.error = '';
                }
            })
                .catch(function () {
                self.errors.pageErrors = 'Error Applying Promo Code';
                self.errors.havePageErrors = true;
                self.showAlert = true;
            })
                .finally(function () { return self.loadingApplypromocode = ''; });
        };
        this.removePromoCode = function (promoCode) {
            var _this = this;
            this.prom = {};
            this.promoCode = promoCode;
            var index = this.promos.findIndex(function (promo) { return promo.promoCode == _this.promoCode; });
            this.promos.splice(index, 1);
            this.CartService.removePromoCode(promoCode)
                .then(function (response) {
            });
        };
        this.hasInvalidPromoCodeDetails = function () {
            var original = this.originalDiscountDebugger || [];
            var current = this.discountDebugger || [];
            return original.length != current.length;
        };
        this.displayDiscountDebugger = function () {
            var addToCartErrorDialog = {
                contentElement: '#discount-debugger-dialog',
                scope: this.$scope,
                preserveScope: true,
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: false,
                parent: angular.element(document.body)
            };
            this.$mdDialog.show(addToCartErrorDialog);
        };
        this.$state = $state;
        this.uiRouterState = $state.current.name;
        this.CartService = CartService;
        this.SettingsService = SettingsService;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.isAkrisOrder = $state.params.isAkrisOrder;
        this.Auth = Auth;
        this.isImpersonated = false;
        var self = this;
        Auth.isLoggedIn(function (loggedInUser) {
            if (loggedInUser) {
                self.isImpersonated = loggedInUser.isImpersonated;
            }
        });
        if (!this.isAkrisOrder) {
            $rootScope.$on('cart-retrieved', function () {
                _this.fillCart(_this.CartService.cartData);
            });
            $rootScope.$on('update-delivery-date', function (event, data) {
                var dateList = data.split('-');
                if (dateList) {
                    _this.deliveryDate = dateList[1] + '/' + dateList[2] + '/' + dateList[0];
                }
            });
        }
    }
    CartSummaryController.prototype.canGetFreeShipping = function () {
        if (this.subTotal - this.discountTotal < this.freeShipping) {
            if (this.shippingAddress && this.shippingAddress.countryCode != 'US') {
                return false;
            }
            return true;
        }
        return false;
    };
    CartSummaryController.prototype.isFreeShipping = function () {
        if (this.subTotal - this.discountTotal >= this.freeShipping) {
            if (this.shippingAddress && this.shippingAddress.countryCode != 'US') {
                return false;
            }
            if ((this.uiRouterState === 'payment' ||
                this.uiRouterState === 'resubmitFailedOrder' ||
                this.uiRouterState === 'placedOrder') && this.shipCost > 0) {
                return false;
            }
            return true;
        }
        return false;
    };
    /*@ngInject*/
    CartSummaryController.prototype.$onInit = function ($scope) {
        var _this = this;
        var self = this;
        this.isExpressCheckout = (sessionStorage.getItem('expressCheckoutStatus') == 'true') ? true : false;
        self.subTotal = 0;
        self.showAlert = false;
        self.errors = {};
        this.SettingsService.getAccount()
            .then(function (res) {
            //If account is on hold show alert.
            if (res.accountingHold) {
                self.errors.pageErrorType = 'warning';
                self.errors.pageErrors = "Your account is currently on hold pending past due payment. As a result, any order submitted will not be shipped until payment is made. Please contact Customer Support at 800-654-4432 so we can assist you with submitting payment and removing the hold on your account.";
                self.errors.havePageErrors = true;
                self.showAlert = true;
            }
            if (!self.payment && self.isExpressCheckout) {
                _this.payment = res.defaultPayment;
                if (res.defaultPayment !== undefined && res.defaultPayment !== null) {
                    _this.billingAddress = res.defaultPayment.billingAddress;
                    _this.paymentType = res.defaultPayment.paymentType;
                    _this.expirationDate = res.defaultPayment.expirationDate;
                }
                else {
                    var isNewRequest = true;
                    _this.CartService.subscribe(_this.$scope, function (event, cart) {
                        self.payment = cart.payment;
                        self.billingAddress = cart.payment.billingAddress;
                        self.paymentType = cart.payment.paymentType;
                        self.expirationDate = cart.payment.expirationDate;
                    }, isNewRequest);
                }
                if (self.paymentType === 'CreditCard') {
                    self.paymentTypeDisplay = 'CREDIT CARD';
                }
                else {
                    self.paymentTypeDisplay = self.paymentType;
                }
            }
        });
        if (self.$state.current.name !== 'placedOrder') {
            this.fillCart(this.CartService.cartData);
            this.CartService.cartCallingFlag = 0;
            if (this.cart === undefined || this.cart === null || !this.cart.aresLineItems) {
                var isNewRequest = true;
                this.CartService.subscribe(this.$scope, function (event, cart) {
                    if (self.$state.current.name === 'cart') {
                        if (_this.CartService.cartCallingFlag > 1) {
                            _this.fillCart(cart);
                        }
                    }
                    else {
                        _this.fillCart(cart);
                    }
                }, isNewRequest);
            }
        }
        else {
            var result = this.CartService.getOrderResult();
            this.fillCart(result.salesOrder);
        }
    };
    CartSummaryController.prototype.$onChanges = function (changes) {
        if (changes.cart) {
            this.cart = Object.assign({}, this.cart);
        }
    };
    CartSummaryController.prototype.fillCart = function (cart) {
        // when cart data is passed in via input binding use that data instead
        if (this.cart && this.cart.aresLineItems) {
            cart = this.cart;
        }
        if (!cart)
            return;
        var self = this;
        self.items = cart.aresLineItems;
        self.quantityOfCartItems = cart.quantityOfCartItems;
        self.CartService.cartCallingFlag = 0;
        self.subTotal = cart.subTotal;
        self.taxTotal = cart.taxTotal;
        self.discountTotal = cart.discountTotal;
        self.shippingAddress = cart.shippingAddress;
        if (cart.shipVia) {
            self.shipVia = self.CartService.getShipViaLabel(cart.shipVia.shipVia || cart.shipVia.shippingMethodId);
            self.shipCost = cart.shipVia.shipCost;
        }
        self.totalShippingDiscount = cart.totalShippingDiscount;
        self.couponCodes = cart.couponCodes;
        self.promos = [];
        if (cart.couponCodes && cart.couponCodes.length) {
            angular.forEach(cart.couponCodes, function (promo) {
                if (promo.promoCode !== "" && promo.promoCode !== 'Automatic' && promo.promoCode.indexOf('_WELL') !== 0) {
                    self.promos.push(promo);
                }
            });
        }
        if (this.promos.length == 0 || this.promos[0].promoCode.length) {
            var newItemNo = this.promos.length + 1;
            self.promos.push({
                "discountName": '',
                "promoCode": '',
            });
        }
        if (cart.payment && !self.isExpressCheckout) {
            self.payment = cart.payment;
            self.billingAddress = cart.payment.billingAddress;
            self.paymentType = cart.payment.paymentType;
            self.expirationDate = cart.payment.expirationDate;
            if (self.paymentType === 'CreditCard') {
                self.paymentTypeDisplay = 'CREDIT CARD';
            }
            else {
                self.paymentTypeDisplay = self.paymentType;
            }
        }
        self.discountDebugger = cart.discountDebugger || [];
        self.originalDiscountDebugger = self.discountDebugger;
    };
    CartSummaryController.prototype.closeDialog = function () {
        this.$mdDialog.hide();
    };
    return CartSummaryController;
}());
export default CartSummaryController;
//# sourceMappingURL=cart-summary.controller.js.map